import React from 'react';
import Hero from './Hero';
import Features from './Features';
import HowItWorks from './HowItWorks';
import Categories from './Categories';
import Testimonials from './Testimonials';
import CTA from './CTA';

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <HowItWorks />
      <Categories />
      <Testimonials />
      <CTA />
    </>
  );
};

export default Home;

